<template lang="pug">
div
  joyStickPanel(ref="joyStickPanel")
  img.roamBtn.up(:src="require('./../../images/modelImage/up.png')" alt='上移' @mousedown='upActive' @mouseup='upDeactive')
  img.roamBtn.down(:src="require('./../../images/modelImage/down.png')" alt='下移' @mousedown='downActive' @mouseup='downDeactive')
  img.roamBtn.back(:src="require('./../../images/modelImage/back.png')" alt='返回' @click='reBack')

</template>

<script>
import joyStickPanel from "../component/joyStickPanel.vue";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";

export default {
  components: {
    joyStickPanel
  },
  mounted () {
    this.init();
  },
  methods: {
    init() {
      // mongeMutations.changeShowApp(false);
      this.$refs.joyStickPanel.activeJoyStickPanel(true);
    },
    upActive() {
      mongeApiMlib.joyStickmoveUp(true);
    },
    upDeactive() {
      mongeApiMlib.joyStickmoveUp(false);
    },
    downActive() {
      mongeApiMlib.joyStickmoveDown(true);
    },
    downDeactive() {
      mongeApiMlib.joyStickmoveDown(false);
    },
    reBack() {
      // mongeMutations.changeShowApp(true);
      this.$emit("closeCom", 'roaming', false);
      this.$refs.joyStickPanel.activeJoyStickPanel(false);
    }
  }

};
</script>

<style lang="scss" scoped>
.roamBtn{
  cursor: pointer;
  position: fixed;
  width: 40px;
  height: 40px;
  z-index: 4;
}
.up{
  right: 30px;
  bottom: 120px;
}
.down{
  right: 30px;
  bottom: 60px;
}
.set{
  width: 30px;
  height: 30px;
  right: 90px;
  bottom: 30px;
}
.back{
  width: 30px;
  height: 30px;
  right: 120px;
  bottom: 60px;
}
.roamSet{
  width: calc(100% - 20px);
}
</style>
